import { cloneElement, isValidElement, useState } from "react";
import "./style.css";

export const FloatingLabelField = ({ label, children, value, onChange }) => {
  const [isFocused, setIsFocused] = useState(false);

  const component = isValidElement(children)
    ? cloneElement(children, {
        value,
        onChange,
        onFocus: () => setIsFocused(true),
        onBlur: () => setIsFocused(false),
      })
    : children;

  return (
    <div className={`relative !mt-5 ${value ? "" : "no-autofill"}`}>
      <label
        className={`z-10 absolute left-2 transition-all duration-300 pointer-events-none bg-white px-1 ${
          isFocused || value
            ? `-top-2 !text-xs ${isFocused ? "text-blue-500" : "text-tgray"}`
            : "top-1/2 transform -translate-y-1/2 text-tgray"
        }`}
      >
        {label}
      </label>
      {component}
    </div>
  );
};
